import type TripPackage from '@itinerary/trip/TripPackage';
import ItineraryLateralLoader from '@itinerary/ItineraryLateralLoader';

export default abstract class TripLateralLoader extends ItineraryLateralLoader {
    abstract override loadItineraries(params: {
        originCode: string;
        destinationCode: string;
        date: Date;
        count: number;
    }): Promise<TripPackage[]>;
}
